import IconButton from 'components/IconButton';
import { useAtomValue } from 'jotai';
import { isAdminUserLoggedIn } from 'lib/helper';
import React from 'react';
import { Badge, Button } from 'reactstrap';

import InviteMemberModal from './InviteMemberModal';
import { selectedRowIdsAtom } from './state';
import SubscriptionModal from './SubscriptionModal';

const BulkActions: React.FC = () => {
  const selectedRowIds = useAtomValue(selectedRowIdsAtom);
  const count = selectedRowIds.length;
  const [isSubscriptionModalOpen, setSubscriptionModalOpen] =
    React.useState(false);

  const [inviationModalOpen, setInviationModalOpen] = React.useState(false);

  return (
    <div className="col-auto p-1 text-right align-baseline">
      {isAdminUserLoggedIn() && (
        <>
          {count > 0 && (
            <>
              <p
                className="d-inline mr-1"
                style={{ fontSize: '1.2em', fontWeight: 500 }}
              >
                <Badge color="primary" pill className="mx-1">
                  {count}
                </Badge>
                Selected
              </p>
              <span
                className="mx-2"
                style={{
                  fontSize: '24px',
                  color: 'gray',
                  verticalAlign: 'middle',
                }}
              >
                &#124;
              </span>
            </>
          )}
          <IconButton
            id="subscriptionButton"
            iconClass="fa fa-bell"
            tooltip="Bulk manage subscriptions for selected members."
            onClick={function (): void {
              setSubscriptionModalOpen(true);
            }}
            disabled={count === 0}
          />
          {isSubscriptionModalOpen && (
            <SubscriptionModal
              toggle={() => setSubscriptionModalOpen(!isSubscriptionModalOpen)}
              isOpen={isSubscriptionModalOpen}
              isBulk
            />
          )}
          <span
            className="mx-2"
            style={{
              fontSize: '15px',
              color: 'gray',
              verticalAlign: 'middle',
            }}
          >
            &#124;
          </span>
        </>
      )}
      <Button
        color="primary"
        onClick={() => setInviationModalOpen(!inviationModalOpen)}
      >
        <i className="fa fa-plus"></i> Invite Member
      </Button>

      {inviationModalOpen && (
        <InviteMemberModal
          toggle={() => setInviationModalOpen(!inviationModalOpen)}
          isOpen={inviationModalOpen}
        />
      )}
    </div>
  );
};

export default BulkActions;
